import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TrademeCoreUiPipeModule } from '@classifieds-sell/shared';
import { TgGridModule, TgLists2Module, TgRackModule } from '@trademe/tangram';
import { SummaryPageOpenHomesSectionComponent } from './summary-page-open-homes-section.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        TgGridModule,
        TgRackModule,
        TgLists2Module,
        TrademeCoreUiPipeModule
    ],
    declarations: [SummaryPageOpenHomesSectionComponent],
    exports: [SummaryPageOpenHomesSectionComponent]
})
export class SummaryPageOpenHomesSectionModule {}
